// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MainFrame-HeaderDropdown-HeaderDropdown-module__box--OdiHB {
  cursor: pointer;
}
/*# sourceMappingURL=HeaderDropdown.module.css.map */`, "",{"version":3,"sources":["webpack://./HeaderDropdown.module.less","webpack://./src/components/MainFrame/HeaderDropdown/HeaderDropdown.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;ACCF;AACA,oDAAoD","sourcesContent":[".box {\n  cursor: pointer;\n}\n",".box {\n  cursor: pointer;\n}\n/*# sourceMappingURL=HeaderDropdown.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-components-MainFrame-HeaderDropdown-HeaderDropdown-module__box--OdiHB`;
export default ___CSS_LOADER_EXPORT___;
